// extracted by mini-css-extract-plugin
module.exports = {"item":"userComment_item_1jBpr","top":"userComment_top_2Ogo2","topr":"userComment_topr_21Tff","user":"userComment_user__uhOb","bottom":"userComment_bottom_3qNpo"};